export class ReportSurfacesIntegration {
    constructor(service) {
        this.service = service;
        this.pendingCollections = new Map();
    }

    async describeMany(surfaceKeys) {
        const requestKey = surfaceKeys.join(',');
        const pending = this.pendingCollections.get(requestKey);
        if (pending) return pending;

        const request = this.service.describeMany(surfaceKeys)
            .then((response) => ({ success: true, data: response.data }))
            .catch((error) => ({ success: false, error }))
            .finally(() => {
                if (this.pendingCollections.get(requestKey) === request) {
                    this.pendingCollections.delete(requestKey);
                }
            });
        this.pendingCollections.set(requestKey, request);
        return request;
    }

    async describe(surfaceKey) {
        try {
            const response = await this.service.describe(surfaceKey);
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, error };
        }
    }
}
